module.exports = __webpack_public_path__ + "static/favicon--baw-a11fe93aa244df8fb143e107a31f6a32.ico";